import { SystemAlertSearchResponse } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export type IAlertItem = ArrayItem<SystemAlertSearchResponse['items']>;

export enum AlertStatus {
  Info = 'Info',
  Warning = 'Warning',
  Incident = 'Incident',
  Promotion = 'Promotion',
  SiteUpdateAlert = 'SiteUpdateAlert',
}
